import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Material theme of the studio
import {
  createMuiTheme,
  ThemeProvider as MuiThemeProvider,
} from "@material-ui/core/styles";
import borealisMaterialUiTheme from "poc-material-ui-theme";

const muiTheme = createMuiTheme(borealisMaterialUiTheme);

const MaterialWrapper = ({ children }) => (
  <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>
);

const staticOrganisations = [
  {
    path: "/kallo",
    value: "1c99dbcc-4582-4b5f-b10a-d26f3f30e606",
  },
  {
    path: "/beringen",
    value: "83ef3479-60b4-463a-97e3-83460b8942b4",
  },
];

ReactDOM.render(
  <React.StrictMode>
    <MaterialWrapper>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          {staticOrganisations.map((route, i) => (
            <Route
              key={i}
              path={route.path}
              element={<App orgId={route.value} />}
            />
          ))}
          <Route path="/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </MaterialWrapper>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
